// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        userName: string;
        email: string;
        firstName: string;
        lastName: string;
        role: string;
        approver: string;
        // XNG-Changes
        company: string;
        phone: string;
        paymentPortalAccess: string;
    } & HasOnSuccess &
        HasOnError<string>,
    AddAccountApiParameter,
    ServiceResult<AccountModel>
>;

export const XngPopulateApiParameter: HandlerType = props => {
    const { company, phone, paymentPortalAccess, ...rest } = props.apiParameter.account as {
        company: string;
        phone: string;
        paymentPortalAccess: string;
    } & typeof props.apiParameter.account;

    props.apiParameter = {
        ...props.apiParameter,
        account: {
            ...rest, // Preserve account properties set by earlier handlers
            properties: {
                ...(props.apiParameter.account?.properties || {}), // Preserve existing properties
                company,
                phone,
                paymentPortalAccess,
            },
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
